import React from 'react'
import CrmEmpty from "../CrmEmpty";
import { Table, Spin, Row, Col } from 'antd';
import moment from 'moment-jalaali';
import strings from "../../../../utils/strings";
import StringHelper from '../../../helpers/StringHelper';
import CrmCallModal from '../crmCallHistory/CrmCallModal';
import { useReportsStore } from '../../../../store/slices/createReportsSlice';
import { useGeneralStore } from '../../../../store/slices/createGeneralSlice';


export default function CrmCalls({ Item }) {
    const reports = useReportsStore();
    const general = useGeneralStore();
    const data = reports.crmCalls.data;
    const loading = reports.crmCalls.loading;

    const requestId = Item?.requestId
    const usrUserID = Item?.applicantUserId ? Item?.applicantUserId : Item?.UserId

    const columns = [
        {
            title: 'کد تماس',
            dataIndex: 'Id',
            width: 60,
            render: (text) => StringHelper.getFarsiNum(text)
        },
        {
            title: "نام کاربری",
            dataIndex: "UserName",
            key: "UserName",
            width: 130,
            sorter: (a, b) => {
                let first = "";
                let second = "";
                a.UserName ? (first = a.UserName) : (first = "");
                b.UserName ? (second = b.UserName) : (second = "");
                return first.localeCompare(second);
            },


        },
        {
            title: 'شناسه کاربر',
            dataIndex: 'UserId',
            key: 'UserId',
            width: 130,
        },
        {
            title: 'شماره همراه',
            dataIndex: "PhoneNumber",
            key: "PhoneNumber",
            width: 130,
            sorter: (a, b) => {
                let first = "";
                let second = "";
                a.PhoneNumber ? (first = a.PhoneNumber) : (first = "");
                b.PhoneNumber ? (second = b.PhoneNumber) : (second = "");
                return first.localeCompare(second);
            },


        },
        {
            title: 'دلیل تماس',
            dataIndex: 'ReasonTitle',
            width: 160,
            key: 'ReasonTitle',
            render: text => strings.getFarsiNum(text),
        },
        {
            title: 'وضعیت تماس',
            dataIndex: 'CallStatusTitle',
            width: 110,
            key: 'CallStatusTitle',
        },
        {
            title: 'نوع تماس',
            dataIndex: 'CallTypeTitle',
            width: 110,
            key: 'CallTypeTitle',
            render: text => strings.getFarsiNum(text),
        },
        {
            title: 'تاریخ ثبت',
            dataIndex: 'CreationTime',
            key: 'CreationTime',
            width: 130,
            render: data => data && strings.getFarsiNum(moment(data).format('jYYYY/jMM/jDD'))
        },
        {
            title: "کد رهگیری",
            dataIndex: "RequestNumber",
            key: "RequestNumber",
            width: 150,
            sorter: (a, b) => a.RequestNumber.localeCompare(b.RequestNumber),
        },
        {
            title: "توضیحات",
            dataIndex: "Description",
            width: 300,
            key: "Description",
            render: text => <span style={{ color: '#5ec393' }}>{text}</span>,
        },

    ];

    return (
        <Spin spinning={loading}>
            <Row
                gutter={[16, 16]}>
                <Col span={24}>
                    <button type="primary" className="btn btn-primary waves-effect waves-light float-left  "
                        onClick={() => general.ToggleCrmCallModal(true)}>
                        <i className="fas fa-plus font-size-14 align-middle mr-2"></i> افزودن تماس جدید
                    </button>
                </Col>
            </Row>
            <Col span={24}>

                <div className="animated fadeIn">
                    {data && data.length > 0 ?
                        <Table
                            style={{ overflowX: 'scroll' }}
                            size="small"
                            className="custom-table crm-request-report"
                            bordered
                            loading={loading}
                            rowKey="ID"
                            scroll={true}
                            dataSource={data}
                            columns={columns}
                        />

                        :
                        <CrmEmpty text="تماس یافت نشد" />}
                </div>
                <CrmCallModal requestId={requestId} detailsCall={true} usrUserID={usrUserID} />
            </Col>
        </Spin>


    )
}